import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "positive copy",
  "use": "positive copy-usage",
  "viewBox": "0 0 30.625 30.625",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.625 30.625\" id=\"positive copy\"><path d=\"M15.313,30.625A15.294,15.294,0,0,1,4.5,4.5,15.294,15.294,0,1,1,26.127,26.127,15.2,15.2,0,0,1,15.313,30.625ZM9.406,14.219,7.656,15.86l5.468,5.468,9.844-9.734-1.75-1.751-8.094,8.095L9.406,14.219Z\" transform=\"translate(0 0)\" fill=\"#24a148\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol